import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Popover } from 'element-ui';
import TextAnswer from '@/components/shared/answer-types/text/text.vue';

export default {
    name: 'RaceAvailability',
    props: {
        id: [Number, String],
    },
    components: {
        [Popover.name]: Popover,
        'text-answer': TextAnswer,
    },
    computed: {
        isValidMembershipId() {
            if (this.membershipId && this.membershipId.indexOf(" ") > -1) {
                this.membershipId = this.membershipId.split(" ").join("");
            }

            return !isNaN(this.membershipId) && this.membershipId && this.membershipId.length > 6;
        },
        isValidMembershipOdlId() {
            if (this.membershipOdlId && this.membershipOdlId.indexOf(" ") > -1) {
                this.membershipOdlId = this.membershipOdlId.split(" ").join("");
            }

            return !isNaN(this.membershipOdlId) && this.membershipOdlId && this.membershipOdlId.length > 6;
        },
        userOdlId() {
            if (this.isValidMembershipOdlId) {
                return Number(this.membershipOdlId) + 100000 - 10000000
            }

            return null;
        },
        userId() {
            if (this.isValidMembershipId) {
                return Number(this.membershipId) + 100000 - 10000000
            }

            return null;
        },
        total() {
            return this.items.length
        },
        isValidPrice() {
            if (!this.odlPrice) {
                return false;
            }
            else return true;
        }
    },
    data() {
        return {
            isChecked: false,
            isOpened: null,
            isProcessing: false,
            membershipId: null,
            items: [],

            membershipOdlId: null,
            odlPrice: null
        };
    },
    methods: {
        check() {
            var self = this;
            if (!self.isValidMembershipId) {
                return;
            }

            self.isProcessing = true;
            self.isOpened = null;
            self.isChecked = false;
            self.items = [];
            request.getRaceAvailabilityForUser({ json: `[${self.id}, ${self.userId}, 0]` })
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d && JSON.parse(response.body.d) && JSON.parse(response.body.d).CustomObject) {
                        self.items = JSON.parse(response.body.d).CustomObject.Checks;
                        self.isOpened = JSON.parse(response.body.d).CustomObject.IsOpened;
                        self.isChecked = true;
                    } else {
                        self.$showError("The Athlete with such TI number is not found.");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("The Athlete with such TI number is not found.");
                    });
        },
        addODM() {
            var self = this;
            if (!self.isValidMembershipOdlId) {
                return;
            }
            if (!self.isValidPrice) {
                self.$showError("Please add ODL price");
                return;
            }
            self.isProcessing = true;
            request.setRaceAddOdmForUser({ json: `[${self.id}, ${self.userOdlId}, "${self.odlPrice}"]` })
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d && JSON.parse(response.body.d) && JSON.parse(response.body.d).ResponseStatus == 1) {
                        self.$showSuccess("ODL was added for the user");
                    } else {
                        self.$showError("The Athlete with such TI number is not found.");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("The Athlete with such TI number is not found.");
                    });
                this.resetOdmFields();
        },
        resetOdmFields() {
                this.membershipOdlId = null,
                this.odlPrice = null
        }
    },
    mounted() {
        if (this.membershipId) {
            this.check();
        }
        if (this.membershipOdlId) {
            this.addODM();
        }
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-availability/race-availability.js